import { Callback } from "game-common/models"
import { Circle, Graphics, LINE_CAP } from "pixi.js"

import { drawPanelDisc, panelDiscGlyphColor } from "./close_button"

// The minimap and PiP size cycle sits in the panel's top-right corner. One tap steps to the
// next size and wraps around, using the shared panel-control disc and a resize diagonal.
//
// Why a cycle and not a drag-resize grip: the WHOLE minimap panel is already a grab handle (the part
// of the camp it covers is sometimes the part you need to watch), so a corner that resized on drag
// would be a second meaning for the same gesture a few pixels away -- and a drag target is a poor
// thing to hand a thumb.
export interface MapSizeButtonProps {
    radius: number
    onClick?: Callback
}

export class MapSizeButton extends Graphics {
    private radius: number

    constructor({ radius, onClick }: MapSizeButtonProps) {
        super()
        this.radius = radius

        this.draw(false)

        this.interactive = true
        this.cursor = "pointer"
        // Keep the panel control's forgiving circular target.
        this.hitArea = new Circle(0, 0, radius + 3)

        this.on("mouseover", () => this.draw(true))
        this.on("mouseout", () => this.draw(false))
        if (onClick) {
            this.on("click", onClick)
            this.on("tap", onClick)
        }
    }

    // A diagonal with an arrowhead at each end, running bottom-left to top-right. Drawn from the
    // radius so it holds at both the desktop and the touch size.
    private draw = (hover: boolean) => {
        const r = this.radius
        drawPanelDisc(this, r, hover)

        const arm = r * 0.44
        // Arrowhead legs, a shade shorter than they are from the tip -- any longer and at an 8px
        // radius the two heads touch in the middle and the glyph reads as a blob.
        const head = r * 0.3
        this.lineStyle({
            width: Math.max(1.5, r * 0.17),
            color: panelDiscGlyphColor(hover),
            alpha: 1,
            cap: LINE_CAP.ROUND,
        })
        this.moveTo(-arm, arm)
        this.lineTo(arm, -arm)
        // Top-right head.
        this.moveTo(arm, -arm)
        this.lineTo(arm - head, -arm)
        this.moveTo(arm, -arm)
        this.lineTo(arm, -arm + head)
        // Bottom-left head.
        this.moveTo(-arm, arm)
        this.lineTo(-arm + head, arm)
        this.moveTo(-arm, arm)
        this.lineTo(-arm, arm - head)
        this.lineStyle(0)
    }
}
